import 'maplibre-gl/dist/maplibre-gl.css';

export default class CustomMap {
    animDuration = 2000;
    map;
    placeSource;
    baseLayer;
    start;
    flashGeom;
    listenerKey;

    constructor(el, locations) {
        this.init(el, locations);
    }

    async init(el, locations) {
        const maplibregl = await import('maplibre-gl');

        el.classList.add("map-initialized");
        
        // calculate most extreme locations to set extent
        // find most extreme coordinates
        let minLat = locations[0].lat;
        let maxLat = locations[0].lat;
        let minLon = locations[0].lng;
        let maxLon = locations[0].lng;

        locations.forEach((coord) => {
            if (coord.lat < minLat) {
                minLat = coord.lat;
            }
            if (coord.lat > maxLat) {
                maxLat = coord.lat;
            }
            if (coord.lng < minLon) {
                minLon = coord.lng;
            }
            if (coord.lng > maxLon) {
                maxLon = coord.lng;
            }
        });

        let zoom = 12;

        // calcluate center as average of locations
        const centerLat = minLat + (maxLat - minLat) / 2;
        const centerLon = minLon + (maxLon - minLon) / 2;
        const center = [centerLon, centerLat];
        const maxDistance = 0.01;
        const bounds = [
            [minLon - maxDistance, minLat - maxDistance ],
            [maxLon + maxDistance, maxLat + maxDistance ]
        ];


        const map = new maplibregl.Map({
            style: 'https://tiles.openfreemap.org/styles/liberty',
            center: center,
            zoom: zoom,
            cooperativeGestures: true,
            container: 'map',
        });

        const geolocate = new maplibregl.GeolocateControl({
            positionOptions: {
                enableHighAccuracy: true
            },
            trackUserLocation: true
        });
        map.addControl(geolocate);
        map.on('load', () => {
            //geolocate.trigger();
        });
        map.addControl(new maplibregl.NavigationControl({
            visualizePitch: true,
            visualizeRoll: true,
            trackUserLocation: true,
            showZoom: true,
            showCompass: true
        }));

        map.fitBounds(bounds);

        locations.forEach((feature, i) => {
            setTimeout(() => {
                // create a DOM element for the marker
                const el = document.createElement('div');
                feature.el = el;
                el.className = 'map-location marker';

                el.addEventListener('click', (e) => {
                    const x = e.clientX + document.documentElement.scrollLeft;
                    const y = e.clientY + document.documentElement.scrollTop;
                    this.showOverlay(feature, x, y);
                });

                // add marker to map
                new maplibregl.Marker({element: el})
                    .setLngLat([feature.lng, feature.lat])
                    .addTo(map);

                this.flash(feature);
            }, (i + 1) * 100);
        });

        document.onclick = (e) => {
            // hide active location popup when clicking outside
            if (! e.target.closest('.map-location')) {
                this.hideOverlays();
            }
        }

        map.on("movestart", () => {
            this.hideOverlays();
        });
        map.on("zoomstart", () => { 
            this.hideOverlays();
        });

        this.hideOverlays();
    }

    showOverlay(feature, x, y) {
        this.hideOverlays();

        this.flash(feature);

        const popup = document.getElementById(feature.id);

        if (x > window.innerWidth * 0.65) {
            popup.classList.add('right');
        } else {
            popup.classList.add('left');
        }

        popup.style.setProperty('--map-overlay-left', x + 'px');
        popup.style.setProperty('--map-overlay-top', y + 'px');

        popup.classList.add('active');
        popup.removeAttribute("aria-hidden");

        popup.focus();
    }

    hideOverlays() {
        const popups = document.querySelectorAll('.map-location');
        popups.forEach((popup) => {
            popup.classList.remove('active');
            popup.classList.remove('right');
            popup.classList.remove('left');
            popup.style.removeProperty('--map-overlay-left');
            popup.style.removeProperty('--map-overlay-top');

            popup.setAttribute("aria-hidden", "true");
        });
    }

    flash(feature) {
        feature.el.classList.remove('flash');
        requestAnimationFrame(() => {
            feature.el.classList.add('flash');
        });
    }
}
